import React, { useEffect, useState } from "react";
import { Tag } from "@alifd/next";
const { Group: TagGroup, Selectable: SelectableTag } = Tag;

interface TagItem {
  id?:number;
  tab_name: string;
}

interface TagGroupTagProps {
  children: TagItem[];
  onChange: (item: TagItem) => void;
}

const TagGroupTag: React.FC<TagGroupTagProps> = ({ children = [], onChange }) => {
  const [selectedTag, setSelectedTag] = useState<string | null>(children[0]?.tab_name || null);

  const handleTagClick = (item: TagItem) => {
    setSelectedTag(item.tab_name === selectedTag ? null : item.tab_name);
    // 向父组件传递item
    onChange(item);
  };
  useEffect(() => {
    if(children.length > 0 && !selectedTag){
        setSelectedTag(children[0]?.tab_name || null);
        onChange(children[0]);
    }
  }, [children]);

  return (
    <Tag.Group style={{padding: '10px'}}>
      {children.map((item, index) => {
        return (
          <SelectableTag
            type="primary"
            key={item.tab_name}
            checked={selectedTag === item.tab_name}
            onChange={() => handleTagClick(item)}
          >
            {item.tab_name}
          </SelectableTag>
        );
      })}
    </Tag.Group>
  );
};

export default TagGroupTag;